import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import JobStatusPicker from "./JobStatusPicker";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import LoadJob from "../load/LoadJob";
import AddressJob from "../map/AddressJob";
import { DateTime } from "luxon";
import { api } from "../utils/Api";
import SubplantPicker from "../plant/SubplantPicker";
import JobToInvoiceModal from "../invoice/JobToInvoiceModal";
import { delayedPouringElements } from "../../constants/Job";
import Select from "react-select";
import PriorityPicker from "./PriorityPicker";
import {
	Button,
	Col,
	Row,
	Modal as ModalAntd,
	Form,
	Input,
	notification,
	Tag,
	InputNumber,
} from "antd";
import { EditFilled, PlusOutlined } from "@ant-design/icons";
import JobCheckIn from "./JobCheckIn";
import JobStatusPickerSeller from "./JobStatusPickerSeller";
import QCSamplingListAdd from "./QCSamplingListAdd";
import { useHistory } from "react-router-dom";
import JobProjectSheet from "./JobProjectSheet";
import { getAggregateCogsCost } from "../utils/CogCost";

// const UNRESTRICTED_EMAILS_CONFIRM_YARDS = [
// 	"eliud@gmail.com",
// 	"ec@57concrete.com",
// ];

const JobItem = (props) => {
	const [comments, setComments] = useState(props.job.comments);
	const [comment, setComment] = useState("");
	const [loadSum, setLoadSum] = useState(null);
	const [showLoad, setShowLoad] = useState(false);
	const [showComment, setShowComment] = useState(false);
	const [jobStatus, setJobStatus] = useState(props.job.jobStatus);
	const [jobStatusPrev, setJobStatusPrev] = useState(props.job.jobStatus);
	const [jobStatus2, setJobStatus2] = useState("");
	const [jobTime, setJobTime] = useState();
	const [showMap, setShowMap] = useState(false);
	const [approved, setApproved] = useState(props.job.approved);
	const [restrict, setRestrict] = useState(null);
	const [confirm, setConfirm] = useState(null);
	const [creditHold, setCreditHold] = useState(
		props.job.paymentType === "Credit"
			? props.job.hold || !props.job.creditApproved
			: props.job.hold,
	);
	// const [development, setDevelopment] = useState(props.job.buildDevelopment);
	const [logisticConfirmation, setLogisticConfirmation] = useState(
		props.job.logisticConfirmation,
	);
	const [subplant, setSubplant] = useState(props.job.subplant);
	const [showInvoiceModal, setShowInvoiceModal] = useState(false);
	const [showErrorInvoice, setShowErrorInvoice] = useState(false);
	const [showPouringModal, setShowPouringModal] = useState(false);
	const [jobStatusSellerChange, setJobStatusSellerChange] = useState(false);
	const [fiber, setFiber] = useState(
		props.job.fiberQuantity && props.job.fiberQuantity > 0,
	);
	const [readyToBeScheduledDate, setReadyToBeScheduledDate] = useState(
		props.job.readyToBeScheduledDate || null,
	);
	const [delayedPouringComment, setDelayedPouringComment] = useState("");
	const [priority, setPriority] = useState(props.job.priority || "Low");
	const isPriorityActive =
		localStorage.getItem("email") === "vm@57concrete.com" ||
		localStorage.getItem("email") === "dm@57concrete.com" ||
		localStorage.getItem("email") === "rs@57concrete.com" ||
		localStorage.getItem("email") === "jh@57concrete.com" ||
		localStorage.getItem("email") === "rl@57concrete.com" ||
		localStorage.getItem("email") === "ec@57concrete.com" ||
		localStorage.getItem("email") === "pc@57concrete.com" ||
		localStorage.getItem("email") === "jc@57concrete.com" ||
		localStorage.getItem("email") === "gg@57xgroup.com" ||
		localStorage.getItem("email") === "bp@57concrete.com" ||
		localStorage.getItem("email") === "bpa@57concrete.com" ||
		localStorage.getItem("email") === "jp@57concrete.com" ||
		localStorage.getItem("email") === "dmad@57concrete.com" ||
		localStorage.getItem("email") === "eliud@gmail.com";
	const [openEditCommentModal, setOpenEditCommentModal] = useState(false);
	const [openCheckInModal, setOpenCheckInModal] = useState(false);
	const [currentMeasurement, setCurrentMeasurement] = useState(
		props.job.measurement || false,
	);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [checkInValues, setCheckInValues] = useState({});
	const [isOver30, setIsOver30] = useState(false);
	const [checkInLatitude, setCheckInLatitude] = useState(undefined);
	const [checkInLongitude, setCheckInLongitude] = useState(undefined);
	const [cannotChangeStatus, setCannotChangeStatus] = useState(false);
	const [approvedPrice, setApprovedPrice] = useState(
		props.job.approvedPrice || false,
	);
	const [factoredInvoice, setFactoredInvoice] = useState(
		props.job.factoredInvoice || false,
	);
	const [cogs, setCogs] = useState(0);
	const [showQCSampling, setShowQCSampling] = useState(false);
	const [showJobProject, setShowJobProject] = useState(false);
	const history = useHistory();

	const [balance, setBalance] = useState(props.job.balance);
	const [qbPrice, setQbPrice] = useState(props.job.qbPrice || 0);

	// const [pourDate, setPourDate] = useState(
	// 	props.job.pourDate ? new Date(props.job.pourDate) : undefined,
	// );
	// const [pourYards, setPourYards] = useState(props.job.pourYards || false);
	// const [pourYardsPersisted, setPourYardsPersisted] = useState(
	// 	props.job.pourYards || false,
	// );

	useEffect(() => {
		getLoadData();
		setConfirm(props.job.approved);
		isApproved();
		manageJobStatus();
		calculateIsOver30();
		getLocation();
		calculateCogs();
	}, []);

	const calculateCogs = () => {
		const cogsPrice = getAggregateCogsCost(props.job.aggregate);
		setCogs(cogsPrice);
	};

	const getLocation = () => {
		if (navigator.geolocation) {
			// Success callback
			navigator.geolocation.getCurrentPosition(
				(position) => {
					setCheckInLatitude(position.coords.latitude);
					setCheckInLongitude(position.coords.longitude);
				},
				// Error callback
				(error) => {
					setCheckInLatitude(undefined);
					setCheckInLongitude(undefined);
					openNotification("warning", "Warning", error.message);
				},
			);
		} else {
			setCheckInLatitude(undefined);
			setCheckInLongitude(undefined);
			openNotification(
				"warning",
				"Warning",
				"Geolocation is not supported by this browser.",
			);
		}
	};

	const calculateIsOver30 = () => {
		let sumYards = 0;
		if (props.job.targetYD3) {
			sumYards += props.job.targetYD3;
		}
		if (balance) {
			sumYards += balance;
		}

		if (sumYards < 50) {
			setIsOver30(false);
		} else if (sumYards >= 50) {
			setIsOver30(true);
			// setCurrentMeasurement(props.job.measurement || false);

			// setCheckInValues({
			// 	measurement: props.job.measurement || false,
			// 	measurementYards: props.job.measurementYards || undefined,
			// 	readyForTruck: props.job.readyForTruck || false,
			// 	readyForTruckComments: props.job.readyForTruckComments || undefined,
			// 	lightTowerPositions: props.job.lightTowerPositions || false,
			// 	lightTowerPositionsNumberTag:
			// 		props.job.lightTowerPositionsNumberTag || undefined,
			// 	lightTowerPositionsBrand:
			// 		props.job.lightTowerPositionsBrand || undefined,
			// 	pour: props.job.pour || false,
			// 	jobStatus: props.job.jobStatus,
			// });
		}
		setCurrentMeasurement(props.job.measurement || false);

		setCheckInValues({
			measurement: props.job.measurement || false,
			measurementYards: props.job.measurementYards || undefined,
			readyForTruck: props.job.readyForTruck || false,
			readyForTruckComments: props.job.readyForTruckComments || undefined,
			lightTowerPositions: props.job.lightTowerPositions || false,
			lightTowerPositionsNumberTag:
				props.job.lightTowerPositionsNumberTag || undefined,
			lightTowerPositionsBrand: props.job.lightTowerPositionsBrand || undefined,
			pour: props.job.pour || false,
			jobStatus: props.job.jobStatus,
		});
	};

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const manageJobStatus = () => {
		let status = props.job.jobStatus;
		if (status === "ok") {
			setJobStatus2("Poured");
		} else if (status === "Active") {
			setJobStatus2("Pouring");
		} else if (status === "Confirm") {
			setJobStatus2("A/R Confirmed");
		} else if (status === "Ready to Load") {
			setJobStatus2("Ready to be scheduled");
		}
	};

	const handleNewModal = () => {
		setShowLoad(!showLoad);
		getLoadData();
	};

	const handleQCSampling = () => {
		setShowQCSampling((prev) => !prev);
	};

	const handleJobProject = () => {
		setShowJobProject((prev) => !prev);
	};

	const handleComment = () => {
		setShowComment(!showComment);
	};

	const handleInvoice = () => {
		setShowInvoiceModal(!showInvoiceModal);
	};

	const handlePouringModal = () => {
		setShowPouringModal(!showPouringModal);
	};

	const toggleErrorInvoice = () => {
		setShowErrorInvoice(!showErrorInvoice);
	};

	const isApproved = () => {
		const tipoPago = props.job.customer.paymentType;
		const validado = props.job.approved;

		if (
			localStorage.getItem("role") === "Finance" ||
			tipoPago !== "PrePay" ||
			validado
		) {
			setRestrict(false);
		} else {
			setRestrict(true);
		}

		// regla para habilitar el confirm
		if (validado) {
			setConfirm(true);
		} else {
			if (localStorage.getItem("role") === "Finance" || tipoPago !== "Credit") {
				setConfirm(true);
			} else {
				setConfirm(false);
			}
		}

		// Excepcion i el cliente esta en credit hold no dejar editar nada
		if (creditHold) {
			setConfirm(false);
		}
	};

	const onChangeJobStatus = async (selectedOption) => {
		if (selectedOption) {
			if (
				selectedOption.value === "Operations done (AR)" &&
				approvedPrice === false
			) {
				setJobStatus(jobStatusPrev);
				manageJobStatus();
				openNotification("info", "Info", "Approved Price must be checked");
				return;
			}

			setJobStatus(selectedOption.value);
			setJobStatus2(selectedOption.label);
			setApproved(true);
			setConfirm(true);

			// if (selectedOption.value === "ok") {
			// 	setPourDate(new Date());
			// } else {
			// 	setPourDate(undefined);
			// }

			setCheckInValues((prev) => ({
				...prev,
				jobStatus: selectedOption.value,
			}));

			if (selectedOption.value === "Ready to Load") {
				setReadyToBeScheduledDate(new Date());
				if (
					!(
						localStorage.getItem("email") === "eliud@gmail.com" ||
						localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "fr@57concrete.com"
					)
				) {
					if (!checkInValues.measurement) {
						handleCheckInOpen();
					}
				} else {
					handleCheckInOpen();
				}
			}

			if (selectedOption.value === "Operations done (AR)") {
				const exist = await getInvoiceExistance();
				if (!exist) handleInvoice();
			}

			if (selectedOption.value === "Active") {
				let scheduledDate = new Date(props.job.scheduledDate);
				let nowDate = new Date();
				let diff = props.job.destinationTime
					? parseInt(props.job.destinationTime.split(" ")[0])
					: props.job.destinationMinutes;
				let scheduledDateMin = new Date(scheduledDate.setMinutes(-diff));
				if (nowDate >= scheduledDateMin) {
					handlePouringModal();
				}
			}
		}
	};

	const onChangeJobStatusSeller = async (selectedOption) => {
		if (selectedOption) {
			if (
				selectedOption.value === "Operations done (AR)" &&
				approvedPrice === false
			) {
				setJobStatus(jobStatusPrev);
				manageJobStatus();
				openNotification("info", "Info", "Approved Price must be checked");
				return;
			}

			// if (selectedOption.value === "ok") {
			// 	setPourDate(new Date());
			// } else {
			// 	setPourDate(undefined);
			// }

			setJobStatus(selectedOption.value);
			setJobStatus2(selectedOption.label);
			setJobStatusSellerChange(true);

			setCheckInValues((prev) => ({
				...prev,
				jobStatus: selectedOption.value,
			}));
		}
	};

	const onChangePriority = async (selectedOption) => {
		if (selectedOption) {
			setPriority(selectedOption.value);
		}
	};

	const onChangeJobSubplant = (selectedOption) => {
		if (selectedOption) {
			setSubplant(selectedOption.label);
		}
	};

	const showModal = (e) => {
		e.preventDefault();
		setShowMap(true);
	};

	const hideModal = (e) => {
		setShowMap(false);
	};

	const onChangeCreditHold = (e) => {
		setCreditHold(!creditHold);
		setConfirm(!confirm);
		setJobStatus("Confirm");
	};

	// link job status with color
	const selectColor = (estatus) => {
		if (props.job.customer.creditHold === true) {
			return "#ffffff";
		}

		switch (estatus) {
			case "Trouble":
				return "#7a7977";
			case "Inactive":
				return "#ffffff";
			case "ok":
				return "#7ad765";
			case "Ready to Load":
				return "#208928";
			case "Ready to be scheduled":
				return "#208928";
			case "Active":
				return "#fff569";
			case "Date moved":
				return "#d9a809";
			case "Operations done (AR)":
				return "#fce0a2";
			case "Company cancellation":
				return "#e087fa";
			case "Customer cancellation":
				return "#ad87fa";
			case "Quote":
				return "#c3c2c0";
			case "Confirm":
				return "#31b9f7";
			case "Scheduled":
				return "#e3495d";
			default:
				return "#fff569";
		}
	};

	const setBackgroudColor = () => {
		if (props.job.logisticDate) {
			return "#b9d3fa";
		} else {
			return "white";
		}
	};

	const getInvoiceExistance = async () => {
		const url = api + "/jobinvoice/" + props.job._id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.get(url);
			return true;
		} catch (err) {
			return false;
		}
	};

	// job list for selected date
	const getLoadData = async () => {
		const url = api + "/load/" + props.job._id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const urlJob = api + "/job/" + props.job._id;

		try {
			const { data } = await axios.get(url);
			const suma = data
				.map((viaje) => viaje.yards)
				.reduce((acc, acum) => acc + acum, 0);
			setLoadSum(Math.round(suma * 100) / 100);

			const { data: dataJob } = await axios.get(urlJob);
			setBalance(dataJob.balance);

			const updateJob = {
				loadYD3: Math.round(suma * 100) / 100,
			};

			await axios.patch(urlJob, updateJob);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	// job list for selected date
	const updateLoad = async (status) => {
		const url = api + "/load/" + props.job._id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			const body = {
				status: status,
			};
			if (data.length !== 0) {
				data.forEach(async (load) => {
					const urlUpdate = api + "/load/" + load._id;
					await axios.patch(urlUpdate, body);
				});
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	// update job attributes
	const saveJob = async (type) => {
		const exist = await getInvoiceExistance();

		if (!exist && jobStatus === "Operations done (AR)") {
			toggleErrorInvoice();
			return;
		}

		if (jobStatus === "Confirm" || jobStatus === "Active") {
			updateLoad("waiting");
		}
		if (jobStatus === "Operations done (AR)" || jobStatus === "ok") {
			updateLoad("done");
		}

		let newJob = {
			jobStatus,
			loadYD3: loadSum,
			approved,
			updatedBy: localStorage.getItem("userId"),
			hold: creditHold,
			approved: confirm,
			subplant: subplant,
			priority: priority,
			comments: comments,
			approvedPrice: approvedPrice,
			factoredInvoice: factoredInvoice,
			qbPrice: Number(qbPrice),
		};

		if (jobTime) {
			newJob.scheduledDate = jobTime;
		}

		if (confirm) {
			newJob.approved = true;
		}

		if (type === "logistic") {
			newJob.logisticConfirmation = !logisticConfirmation;
			newJob.logisticComment = comment;
		}

		if (jobStatus !== jobStatusPrev) {
			newJob.jobStatusHistory = {
				user: localStorage.getItem("userId"),
				jobStatus: jobStatus,
			};
		}

		let checkInMadeIt = false;

		if (jobStatus === "Ready to Load") {
			newJob.readyToBeScheduledDate = readyToBeScheduledDate;
			// if (isOver50) {
			// 	if (
			// 		checkInValues.measurement === false &&
			// 		!(
			// 			localStorage.getItem("email") === "eliud@gmail.com" ||
			// 			localStorage.getItem("email") === "ec@57concrete.com" ||
			// 			localStorage.getItem("email") === "bp@57concrete.com" ||
			// 			localStorage.getItem("email") === "jp@57concrete.com" ||
			// 			localStorage.getItem("email") === "vm@57concrete.com" ||
			// 			localStorage.getItem("email") === "dm@57concrete.com" ||
			// 			localStorage.getItem("email") === "rs@57concrete.com"
			// 		)
			// 	) {
			// 		openNotification(
			// 			"warning",
			// 			"Warning",
			// 			"You must check in to change the status Ready To Be Scheduled"
			// 		);
			// 		return;
			// 	} else {
			// 		if (currentMeasurement === false) {
			// 			newJob.checkInLatitude = checkInLatitude;
			// 			newJob.checkInLongitude = checkInLongitude;
			// 		}
			// 		newJob.measurement = checkInValues.measurement;
			// 		newJob.measurementYards = checkInValues.measurementYards;
			// 		newJob.readyForTruck = checkInValues.readyForTruck;
			// 		newJob.readyForTruckComments = checkInValues.readyForTruckComments;
			// 		newJob.lightTowerPositions = checkInValues.lightTowerPositions;
			// 		newJob.lightTowerPositionsNumberTag =
			// 			checkInValues.lightTowerPositionsNumberTag;
			// 		newJob.lightTowerPositionsBrand =
			// 			checkInValues.lightTowerPositionsBrand;
			// 		checkInMadeIt = true;
			// 	}
			// }
		} else if (jobStatus === "ok" || jobStatus === "Active") {
			if (isOver30) newJob.pour = checkInValues.pour;
		}

		if (isOver30) {
			if (
				checkInValues.measurement === false &&
				!(
					localStorage.getItem("email") === "eliud@gmail.com" ||
					localStorage.getItem("email") === "fr@57concrete.com" ||
					localStorage.getItem("email") === "ec@57concrete.com"
				)
			) {
				if (newJob.jobStatus === "Ready to Load") {
					openNotification(
						"warning",
						"Warning",
						"You must check in to change the status Ready To Be Scheduled",
					);
					return;
				}
			} else {
				if (currentMeasurement === false) {
					newJob.checkInLatitude = checkInLatitude;
					newJob.checkInLongitude = checkInLongitude;
				}
				newJob.measurement = checkInValues.measurement;
				newJob.measurementYards = checkInValues.measurementYards;
				newJob.readyForTruck = checkInValues.readyForTruck;
				newJob.readyForTruckComments = checkInValues.readyForTruckComments;
				newJob.lightTowerPositions = checkInValues.lightTowerPositions;
				newJob.lightTowerPositionsNumberTag =
					checkInValues.lightTowerPositionsNumberTag;
				newJob.lightTowerPositionsBrand =
					checkInValues.lightTowerPositionsBrand;
				checkInMadeIt = true;
			}
		} else {
			newJob.measurement = checkInValues.measurement;
			newJob.measurementYards = checkInValues.measurementYards;
			newJob.readyForTruck = checkInValues.readyForTruck;
			newJob.readyForTruckComments = checkInValues.readyForTruckComments;
			newJob.lightTowerPositions = checkInValues.lightTowerPositions;
			newJob.lightTowerPositionsNumberTag =
				checkInValues.lightTowerPositionsNumberTag;
			newJob.lightTowerPositionsBrand = checkInValues.lightTowerPositionsBrand;
		}

		if (delayedPouringComment !== "") {
			newJob.delayedPouringComment = delayedPouringComment;
		}

		if (cannotChangeStatus && isOver30) {
			openNotification(
				"warning",
				"Warning",
				"You cannot save job until Check In is made",
			);
			return;
		}

		// if (pourDate) {
		// 	newJob.pourDate = pourDate;
		// }

		// newJob.pourYards = pourYards;

		const url = api + "/job/" + props.job._id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		// const urlLog = api + "/jobhistory";

		// const antiguo = {
		// 	funding: props.job.funding,
		// 	taxExemptJob: props.job.taxExemptJob,
		// 	contractorType: props.job.contractorType,
		// 	ownerState: props.job.ownerState,
		// 	suretyState: props.job.suretyState,
		// 	balance: props.job.balance,
		// 	propsStatus: props.job.jobStatus,
		// 	slump: props.job.slupm,
		// 	paid: props.job.paid,
		// 	isPhoneQuote: props.job.isPhoneQuote,
		// 	hasInvoice: props.job.hasInvoice,
		// 	approved: props.job.approved,
		// 	customer: props.job.customer,
		// 	name: props.job.name,
		// 	loadYD3: props.job.loadYD3,
		// 	targetYD3: props.job.targetYD3,
		// 	shipAddress: props.job.shipAddress,
		// 	propsForeman: props.job.jobForeman,
		// 	foremanPhone: props.job.foremanPhone,
		// 	apContact: props.job.apContact,
		// 	apPhone: props.job.apPhone,
		// 	scheduledDate: props.job.scheduledDate,
		// 	destinationMinutes: props.job.destinationMinutes,
		// 	comments: props.job.comments,
		// 	po: props.job.po,
		// 	jobDuration: props.job.jobDuration,
		// 	unitPrice: props.job.unitPrice,
		// 	jobPoor: props.job.jobPoor,
		// 	jobType: props.job.jobType,
		// 	number: props.job.number,
		// 	seller: props.job.seller,
		// 	psi: props.job.psi,
		// 	destinationTime: props.job.destinationTime,
		// 	distance: props.job.distance,
		// 	latitude: props.job.latitude,
		// 	longitude: props.job.longitude,
		// 	paymentType: props.job.paymentType,
		// 	firstShipementDate: props.job.firstShipementDate,
		// 	scheduledTime: props.job.scheduledTime,
		// 	createdBy: localStorage.getItem("userId"),
		// 	updatedBy: localStorage.getItem("userId"),
		// };

		try {
			await axios.patch(url, newJob);
			// await axios.post(urlLog, antiguo);

			// if (isOver50 && checkInMadeIt && currentMeasurement === false) {
			// 	sendEmailToTeamCheckIn();
			// }

			// setPourYardsPersisted(pourYards);

			if (type === "normal") props.wic();
			if (jobStatus === "Scheduled") {
				if (props.job.jobStatus !== jobStatus) {
					props.action(true);
				}
			} else if (props.job.jobStatus === "Scheduled") {
				if (props.job.jobStatus !== jobStatus) {
					props.action(true);
				}
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const sendEmailToTeamCheckIn = async () => {
		const url = api + `/job/checkin/${props.job._id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.post(url);
		} catch (err) {
			console.error(err.message);
		}
	};

	const changeTime = (e) => {
		const fecha = DateTime.fromISO(props.job.scheduledDate);
		const anio = fecha.year;
		const mes = fecha.month;
		const dia = fecha.day;
		const [hora, minuto] = e.target.value.split(":");
		const newDate = new Date(anio, mes - 1, dia, hora, minuto, 0, 0);
		setJobTime(newDate);
	};

	const manageConfirm = (e) => {
		setConfirm((prev) => !prev);
		// setConfirm(!confirm);
	};

	const manageLogisticConfirmation = (e) => {
		e.preventDefault();
		saveJob("logistic");
		setLogisticConfirmation(!logisticConfirmation);
		handleComment();
	};

	const onSelectPouringComment = (selected) => {
		if (selected) {
			setDelayedPouringComment(selected.value);
		}
	};

	const handleEditCommentOpen = () => {
		setOpenEditCommentModal(true);
	};

	const handleEditCommentCancel = () => {
		setOpenEditCommentModal(false);
	};

	const [formComment] = Form.useForm();

	const onFinishComment = (values) => {
		setComments(values.comments);
		handleEditCommentCancel();
	};

	const handleCheckInCancel = () => {
		setOpenCheckInModal(false);
	};

	const handleCheckInOpen = async () => {
		if (checkInValues.measurement === false && isOver30) {
			if (
				localStorage.getItem("email") === "eliud@gmail.com" ||
				localStorage.getItem("email") === "ec@57concrete.com" ||
				localStorage.getItem("email") === "fr@57concrete.com"
			) {
				setOpenCheckInModal(true);
				setCannotChangeStatus(false);
			} else {
				const isInCoords = await checkSellerPosition(
					props.job.latitude,
					props.job.longitude,
				);
				if (isInCoords) {
					setOpenCheckInModal(true);
					setCannotChangeStatus(false);
				} else {
					setCannotChangeStatus(true);
					openNotification(
						"warning",
						"Warning",
						"You must be at job direction to make check in",
					);
				}
			}
		} else {
			// if (isOver30) {
			setOpenCheckInModal(true);
			// }
			setCannotChangeStatus(false);
		}
	};

	const checkSellerPosition = async (jobLatitude, jobLongitude) => {
		const url = api + `/job/seller/position`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const body = {
				sellerLatitude: props.job.checkInLatitude,
				sellerLongitude: props.job.checkInLongitude,
				jobLatitude: jobLatitude,
				jobLongitude: jobLongitude,
			};
			const { data } = await axios.post(url, body);
			if (data.success) {
				return data.payload;
			} else {
				return false;
			}
		} catch (err) {
			console.error(err.message);
			return false;
		}
	};

	const RenderEditCommentModal = () => {
		return (
			<ModalAntd
				title={`Edit comment of Job #${props.job.number}`}
				open={openEditCommentModal}
				onCancel={handleEditCommentCancel}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
			>
				<Form
					form={formComment}
					layout="vertical"
					onFinish={onFinishComment}
					initialValues={{ comments: comments || undefined }}
				>
					<Form.Item label="Comments" name="comments">
						<Input.TextArea size="large" />
					</Form.Item>
					<Button type="primary" htmlType="submit">
						Update
					</Button>
				</Form>
			</ModalAntd>
		);
	};

	const RenderCheckInModal = () => {
		return (
			<ModalAntd
				title="Job Check In"
				open={openCheckInModal}
				onCancel={handleCheckInCancel}
				cancelButtonProps={{
					style: { display: "none" },
				}}
				okButtonProps={{
					style: { display: "none" },
				}}
				width={600}
			>
				<JobCheckIn
					values={props.job}
					setCheckInValues={setCheckInValues}
					handleCheckInCancel={handleCheckInCancel}
				/>
			</ModalAntd>
		);
	};

	const showEtickets = () => {
		const url = "/eticketsjob/" + props.job._id;
		history.push(url);
	};

	const allowedEmailsScheduled = [
		"rs@57concrete.com",
		"fr@57concrete.com",
		"jp@57concrete.com",
		"ji@57concrete.com",
		"eliud@gmail.com",
	];

	const currentEmail = localStorage.getItem("email");

	const currentStatus = jobStatus || props.job.jobStatus;

	const canViewJobStatusPicker =
		currentStatus !== "Scheduled" ||
		allowedEmailsScheduled.includes(currentEmail);

	const canEditScheduledTime =
		currentStatus !== "Scheduled" ||
		allowedEmailsScheduled.includes(currentEmail);

	// const canEditPouredYards = () => {
	// 	const email = localStorage.getItem("email");

	// 	if (UNRESTRICTED_EMAILS_CONFIRM_YARDS.includes(email)) {
	// 		return true;
	// 	}

	// 	if (pourYardsPersisted === true) {
	// 		return false;
	// 	}

	// 	const currentStatus = jobStatus || props.job.jobStatus;
	// 	if (currentStatus === "Active") {
	// 		return true;
	// 	}

	// 	const now = new Date();

	// 	if (pourDate) {
	// 		const pouredDatePlus2h = new Date(
	// 			new Date(pourDate).getTime() + 2 * 60 * 60 * 1000,
	// 		);
	// 		const result = now < pouredDatePlus2h;
	// 		return result;
	// 	}

	// 	const scheduled = new Date(props.job.scheduledDate);
	// 	const diffHours = (scheduled.getTime() - now.getTime()) / (1000 * 60 * 60);
	// 	const result = now < scheduled && diffHours < 2;
	// 	return result;
	// };

	// const onChangePouredYards = (e) => {
	// 	if (!canEditPouredYards()) {
	// 		openNotification(
	// 			"warning",
	// 			"Warning",
	// 			"You are not allowed to modify poured yards at this time",
	// 		);
	// 		return;
	// 	}

	// 	const checked = e.target.checked;
	// 	setPourYards(checked);
	// };

	return (
		<tr className="small" bgcolor={setBackgroudColor()}>
			<td>
				{!creditHold && (
					<input
						name="confirm"
						type="checkbox"
						checked={confirm ? confirm : props.job.approved}
						onChange={manageConfirm}
						disabled={
							!(
								localStorage.getItem("email") === "eliud@gmail.com" ||
								localStorage.getItem("email") === "ec@57concrete.com" ||
								localStorage.getItem("email") === "mv@57concrete.com" ||
								localStorage.getItem("email") === "al@57concrete.com" ||
								localStorage.getItem("email") === "vo@57concrete.com" ||
								localStorage.getItem("email") === "mb@57concrete.com" ||
								localStorage.getItem("email") === "jp@57concrete.com" ||
								localStorage.getItem("email") === "bp@57concrete.com" ||
								localStorage.getItem("email") === "bpa@57concrete.com" ||
								localStorage.getItem("email") === "wc@57concrete.com" ||
								localStorage.getItem("email") === "dm@57concrete.com" ||
								localStorage.getItem("email") === "bm@57concrete.com" ||
								localStorage.getItem("email") === "rl@57concrete.com" ||
								localStorage.getItem("email") === "mrg@57concrete.com" ||
								localStorage.getItem("email") === "pc@57concrete.com" ||
								localStorage.getItem("email") === "gg@57xgroup.com" ||
								localStorage.getItem("email") === "scale@filegonia.com" ||
								localStorage.getItem("email") === "jc@57concrete.com" ||
								localStorage.getItem("email") === "reyesss22@icloud.com" ||
								localStorage.getItem("email") === "office@57logistics.com"
							) || localStorage.getItem("email") === "jh@57concrete.com"
						}
					/>
				)}
				{creditHold && (
					<div>
						<input
							name="onlyRead"
							type="checkbox"
							checked={confirm}
							onChange={manageConfirm}
							disabled={
								!(
									localStorage.getItem("email") === "eliud@gmail.com" ||
									localStorage.getItem("email") === "ec@57concrete.com" ||
									localStorage.getItem("email") === "mv@57concrete.com" ||
									localStorage.getItem("email") === "al@57concrete.com" ||
									localStorage.getItem("email") === "vo@57concrete.com" ||
									localStorage.getItem("email") === "mb@57concrete.com" ||
									localStorage.getItem("email") === "jp@57concrete.com" ||
									localStorage.getItem("email") === "bp@57concrete.com" ||
									localStorage.getItem("email") === "bpa@57concrete.com" ||
									localStorage.getItem("email") === "wc@57concrete.com" ||
									localStorage.getItem("email") === "dm@57concrete.com" ||
									localStorage.getItem("email") === "bm@57concrete.com" ||
									localStorage.getItem("email") === "rl@57concrete.com" ||
									localStorage.getItem("email") === "mrg@57concrete.com" ||
									localStorage.getItem("email") === "pc@57concrete.com" ||
									localStorage.getItem("email") === "gg@57xgroup.com" ||
									localStorage.getItem("email") === "scale@filegonia.com" ||
									localStorage.getItem("email") === "jc@57concrete.com" ||
									localStorage.getItem("email") === "reyesss22@icloud.com" ||
									localStorage.getItem("email") === "office@57logistics.com"
								) || localStorage.getItem("email") === "jh@57concrete.com"
							}
						/>
						<label>
							<strong>Credit on Hold</strong>
						</label>
					</div>
				)}
			</td>
			<td>{props.job.number}</td>
			<td>
				<Link to={"/job/" + props.job._id}>
					{props.job.customer
						? props.job.customer.customerNumber +
							" " +
							props.job.customer.name +
							" ph: " +
							props.job.foremanPhone
						: "No customer assigned!"}
				</Link>
			</td>
			<td>{props.job.customerPONumber || ""}</td>
			<td>
				{props.job.seller ? props.job.seller.name : props.job.associateName}
			</td>
			{!props.hideRestrictedFields && (
				<>
					<td>
						{props.job.foreman
							? `${props.job.foreman.firstName} ${props.job.foreman.lastName}`
							: "NA"}
					</td>
					<td>{props.job.foreman ? props.job.foreman.phone : "-"}</td>
					<td>
						<input
							name="plantChanged"
							type="checkbox"
							checked={props.job.plantChanged || false}
							readOnly
						/>
					</td>
					<td>
						{subplant ? subplant : props.job.subplant}
						<br />
						<SubplantPicker
							plant={props.job.plant._id}
							action={onChangeJobSubplant}
							value={subplant}
							isRequired={false}
						/>
					</td>
				</>
			)}
			<td style={{ fontSize: "15px" }}>
				{new Date(props.job.scheduledDate).toLocaleTimeString([], {
					timeStyle: "short",
				})}
				{canEditScheduledTime && (
					<input type="time" id="time" name="time" onChange={changeTime} />
				)}
			</td>
			<td>
				<Link onClick={showModal} to="#">
					{props.job.customerShipAddress
						? props.job.customerShipAddress + " - " + props.job.shipAddress
						: props.job.shipAddress}
				</Link>
				<Modal show={showMap} animation={false} onHide={hideModal}>
					<Modal.Header closeButton>
						<Modal.Title>{props.job.shipAddress}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<AddressJob
							lat={props.job.latitude}
							lng={props.job.longitude}
							address={props.job.shipAddress}
							plant={props.job.plant._id}
						/>
					</Modal.Body>
				</Modal>
			</td>
			<td>
				{loadSum}
				<br />
				{((jobStatus === "Inactive" && confirm) ||
					(jobStatus === "Confirm" && confirm) ||
					(jobStatus === "Active" && confirm) ||
					(jobStatus === "ok" && confirm)) && (
					<button className="button btn-primary" onClick={handleNewModal}>
						+
					</button>
				)}
				<Modal
					show={showLoad}
					onHide={handleNewModal}
					animation={false}
					size="xl"
					centered
				>
					<Modal.Header closeButton>
						<Modal.Title>
							<div className="col-sm-12">
								Load YD3. JobID = {props.job.number}
							</div>
							{(localStorage.getItem("email") === "mv@57concrete.com" ||
								localStorage.getItem("email") === "al@57concrete.com" ||
								localStorage.getItem("email") === "ec@57concrete.com" ||
								localStorage.getItem("email") === "pc@57concrete.com" ||
								localStorage.getItem("email") === "jc@57concrete.com" ||
								localStorage.getItem("email") === "gg@57xgroup.com" ||
								localStorage.getItem("email") === "fc@57concrete.com" ||
								localStorage.getItem("email") === "bp@57concrete.com" ||
								localStorage.getItem("email") === "bpa@57concrete.com" ||
								localStorage.getItem("email") === "vm@57concrete.com" ||
								localStorage.getItem("email") === "jp@57concrete.com" ||
								localStorage.getItem("email") === "eliud@gmail.com") && (
								<div className="col-sm-12">
									<button
										className={`btn ${
											logisticConfirmation ? "btn-success" : "btn-danger"
										}`}
										onClick={handleComment}
									>
										Logistics confirmation
									</button>
								</div>
							)}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<LoadJob pcb={props.pcb} job={props.job} />
					</Modal.Body>
				</Modal>
				<Modal
					show={showComment}
					onHide={handleComment}
					animation={false}
					size="sm"
					centered
				>
					<Modal.Header closeButton>
						<Modal.Title>Add comment to logistic confirmation</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<form className="form" onSubmit={manageLogisticConfirmation}>
							<div className="form-group row">
								<div className="col-sm-12">
									<input
										type="text"
										name="comment"
										placeholder="Comment"
										value={comment}
										required
										className="form-control"
										onChange={(e) => setComment(e.target.value)}
									/>
								</div>
								<div className="col-sm-12">
									<button type="submit" className="btn btn-success">
										Save
									</button>
								</div>
							</div>
						</form>
					</Modal.Body>
				</Modal>
			</td>
			<td>
				{balance
					? (typeof props.job.targetYD3 === "string"
							? props.job.targetYD3
							: props.job.targetYD3.toString()) +
						" + " +
						balance
					: (typeof props.job.targetYD3 === "string"
							? props.job.targetYD3
							: props.job.targetYD3.toString()) + " + 0"}
			</td>
			<td>{props.job.deliveryRate ?? "-"}</td>
			{!props.hideRestrictedFields && (
				<>
					<td>
						{props.job.performanceOnTime === undefined ? (
							"-"
						) : (
							<input
								name="performanceOnTime"
								type="checkbox"
								checked={props.job.performanceOnTime || false}
								readOnly
							/>
						)}
					</td>
					<td>
						{props.job.destinationTime
							? props.job.destinationTime
							: props.job.destinationMinutes}
					</td>
					<td>{props.job.distance}</td>
				</>
			)}
			<td>{props.job.psi}</td>
			<td>{props.job.slump}</td>
			<td>
				<input
					name="fiber"
					type="checkbox"
					checked={fiber}
					onChange={(e) => setFiber(e.target.checked)}
				/>
				{props.job.fiberQuantity && (
					<label>
						<strong>{props.job.fiberQuantity}</strong>
					</label>
				)}
			</td>
			<td>
				${" "}
				{Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
					cogs,
					// props.job.psiId
					// 	? props.job.psiId.materialCost
					// 		? props.job.psiId.materialCost
					// 		: 0
					// 	: 0
				)}
			</td>
			<td>$ {Intl.NumberFormat("en-US").format(props.job.unitPrice)}</td>
			<td>
				${" "}
				{Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
					props.job.unitPrice - cogs,
				)}
			</td>
			<td>
				<input
					name="approvedPrice"
					type="checkbox"
					checked={approvedPrice}
					onChange={(e) => setApprovedPrice(e.target.checked)}
					disabled={
						!(
							localStorage.getItem("email") === "eliud@gmail.com" ||
							localStorage.getItem("email") === "ec@57concrete.com" ||
							localStorage.getItem("email") === "pc@57concrete.com" ||
							localStorage.getItem("email") === "jc@57concrete.com" ||
							localStorage.getItem("email") === "gg@57xgroup.com"
						)
					}
				/>
				<label>
					<strong>EC</strong>
				</label>
			</td>
			<td>
				{localStorage.getItem("email") === "eliud@gmail.com" ||
				localStorage.getItem("email") === "mgr@57concrete.com" ||
				localStorage.getItem("email") === "bm@57concrete.com" ? (
					<div style={{ display: "flex", flexDirection: "row" }}>
						$
						<input
							type="number"
							value={qbPrice}
							onChange={(e) => setQbPrice(e.target.value)}
							style={{
								width: "90px",
								border: "none",
								background: "transparent",
							}}
							prefix="$"
						/>
					</div>
				) : (
					<div>$ {Intl.NumberFormat("en-US").format(qbPrice)}</div>
				)}
			</td>
			{!props.hideRestrictedFields && (
				<>
					<td>
						<input
							name="factoredInvoice"
							type="checkbox"
							checked={factoredInvoice}
							onChange={(e) => setFactoredInvoice(e.target.checked)}
							disabled={
								!(
									localStorage.getItem("email") === "eliud@gmail.com" ||
									localStorage.getItem("email") === "ec@57concrete.com" ||
									localStorage.getItem("email") === "pc@57concrete.com" ||
									localStorage.getItem("email") === "jc@57concrete.com" ||
									localStorage.getItem("email") === "gg@57xgroup.com"
								)
							}
						/>
						<label>
							<strong>Yes / No</strong>
						</label>
					</td>
					<td>
						${" "}
						{Intl.NumberFormat("en-US").format(
							props.job.psiId
								? props.job.psiId.minPrice
									? props.job.psiId.minPrice
									: 0
								: 0,
						)}
					</td>
					<td>
						${" "}
						{Intl.NumberFormat("en-US").format(
							props.job.psiId
								? props.job.psiId.price
									? props.job.psiId.price
									: 0
								: 0,
						)}
					</td>
				</>
			)}
			<td>{props.job.jobPoor + " / " + props.job.jobType}</td>
			<td
				style={{
					background: selectColor(jobStatus ? jobStatus : props.job.jobStatus),
				}}
			>
				{props.job.customer.creditHold === true
					? "Inactive"
					: jobStatus2
						? jobStatus2
						: props.job.jobStatus}
				{/* {jobStatus2 ? jobStatus2 : props.job.jobStatus} */}
				<br />
				{!restrict &&
					confirm &&
					props.job.customer.creditHold === false &&
					canViewJobStatusPicker && (
						<JobStatusPicker action={onChangeJobStatus} />
					)}
				{!(!restrict && confirm && props.job.customer.creditHold === false) &&
					localStorage.getItem("role") === "Seller" &&
					canViewJobStatusPicker && (
						<JobStatusPickerSeller action={onChangeJobStatusSeller} />
					)}
				<Modal
					show={showPouringModal}
					onHide={handlePouringModal}
					animation={false}
					size="md"
					centered
				>
					<Modal.Header closeButton>
						<Modal.Title>Delayed Pouring Comment</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Select
							name="form-field-name"
							placeholder="Comment..."
							onChange={onSelectPouringComment}
							options={delayedPouringElements}
						/>
						<div className="py-2">
							<button
								type="button"
								className="btn btn-success"
								onClick={handlePouringModal}
							>
								OK
							</button>
						</div>
					</Modal.Body>
				</Modal>
				<Modal
					show={showInvoiceModal}
					onHide={handleInvoice}
					animation={false}
					size="xl"
					centered
				>
					<Modal.Header closeButton>
						<Modal.Title>Invoice Generator</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<JobToInvoiceModal
							jobId={props.job._id}
							pcb={handleInvoice}
							history={props.history}
						/>
					</Modal.Body>
				</Modal>
				<Modal
					show={showErrorInvoice}
					onHide={toggleErrorInvoice}
					animation={false}
					size="sm"
					centered
				>
					<Modal.Header closeButton>
						<Modal.Title>Save Warning</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>You can't save changes until invoice is generated</p>
					</Modal.Body>
				</Modal>
			</td>
			<td>
				{}
				{readyToBeScheduledDate
					? `${new Date(
							readyToBeScheduledDate,
						).toLocaleDateString()} - ${new Date(
							readyToBeScheduledDate,
						).toLocaleTimeString([], { timeStyle: "short" })}`
					: "-"}
			</td>
			{(localStorage.getItem("jobHold") === "true" ? true : false) && (
				<td>
					<div>
						<input
							name="creditHold"
							type="checkbox"
							checked={creditHold}
							onChange={onChangeCreditHold}
							disabled={
								localStorage.getItem("email") === "rl@57concrete.com" ||
								localStorage.getItem("email") === "vc@57concrete.com" ||
								localStorage.getItem("email") === "jh@57concrete.com" ||
								localStorage.getItem("email") === "jvb@57concrete.com"
							}
						/>
						{creditHold && (
							<label>
								<strong>Job Hold</strong>
							</label>
						)}
					</div>
				</td>
			)}
			<td>
				<input
					name="measurement"
					type="checkbox"
					checked={props.job.measurement || false}
					readOnly
				/>
			</td>
			<td>
				<input
					name="iceSurcharge"
					type="checkbox"
					checked={
						props.job.iceSurcharge && props.job.iceSurcharge !== 0
							? true
							: false
					}
					readOnly
				/>
			</td>
			<td>
				<input
					name="lightSurcharge"
					type="checkbox"
					checked={
						props.job.lightSurcharge && props.job.lightSurcharge !== 0
							? true
							: false
					}
					readOnly
				/>
			</td>
			<td>
				<input
					name="pour"
					type="checkbox"
					checked={props.job.pour || false}
					readOnly
				/>
				{/* <input
					name="pourYards"
					type="checkbox"
					checked={pourYards}
					onChange={onChangePouredYards}
					disabled={!canEditPouredYards()}
				/> */}
			</td>
			<td>
				<input
					name="qualityControl"
					type="checkbox"
					checked={props.job.qualityControl || false}
					readOnly
				/>
				{/* <button className="button btn-primary" onClick={handleQCSampling}>
					+
				</button>

				<Modal
					show={showQCSampling}
					onHide={handleQCSampling}
					animation={false}
					size="xl"
					centered
				>
					<Modal.Header closeButton>
						<Modal.Title>
							<div className="col-sm-12">QA/QC Job ID: {props.job.number}</div>
							{props.job.qualityControl && (
								<div className="col-sm-12">
									{props.job.qcType} {props.job.qcName} {props.job.qcTechnical}
								</div>
							)}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<QCSamplingListAdd jobId={props.job._id} />
					</Modal.Body>
				</Modal> */}
			</td>
			<td>
				<Button
					type="primary"
					size="large"
					onClick={showEtickets}
					disabled={
						!(
							props.job.jobStatus === "ok" ||
							props.job.jobStatus === "Active" ||
							props.job.jobStatus === "Confirm" ||
							props.job.jobStatus === "Operations done (AR)"
						)
					}
				>
					Etickets
				</Button>
			</td>

			{/* <td>
				<button className="button btn-primary" onClick={handleJobProject}>
					+
				</button>

				<Modal
					show={showJobProject}
					onHide={handleJobProject}
					animation={false}
					size="xl"
					centered
				>
					<Modal.Header closeButton>
						<Modal.Title>
							<div className="col-sm-12">Job ID: {props.job.number}</div>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<JobProjectSheet job={props.job} />
					</Modal.Body>
				</Modal>
			</td> */}

			{isPriorityActive && (
				<td>
					{priority}
					<PriorityPicker action={onChangePriority} value={priority} />
				</td>
			)}

			<td>
				<Row>
					<Col>{comments}</Col>
					<Col>
						<Button icon={<EditFilled />} onClick={handleEditCommentOpen} />
						<RenderEditCommentModal />
					</Col>
				</Row>
			</td>
			<td>
				<Tag
					color={
						props.job.franchise === "57Concrete" ||
						props.job.franchise === null ||
						props.job.franchise === undefined
							? "blue"
							: props.job.franchise === "Castle"
								? "green"
								: "cyan"
					}
				>
					{props.job.franchise || "57Concrete"}
				</Tag>
			</td>
			<td>
				{(localStorage.getItem("email") === "mv@57concrete.com" ||
					localStorage.getItem("email") === "al@57concrete.com" ||
					localStorage.getItem("email") === "ec@57concrete.com" ||
					localStorage.getItem("email") === "eliud@gmail.com" ||
					localStorage.getItem("email") === "mgr@57concrete.com" ||
					localStorage.getItem("email") === "pc@57concrete.com" ||
					localStorage.getItem("email") === "gg@57xgroup.com" ||
					localStorage.getItem("email") === "scale@filegonia.com" ||
					localStorage.getItem("email") === "jc@57concrete.com" ||
					localStorage.getItem("email") === "reyesss22@icloud.com" ||
					localStorage.getItem("email") === "office@57logistics.com" ||
					confirm ||
					jobStatusSellerChange) && (
					<button className="btn btn-success" onClick={() => saveJob("normal")}>
						Save
					</button>
				)}
			</td>
			<RenderCheckInModal />
			{contextHolder}
		</tr>
	);
};

export default JobItem;
